import { Card, CardHeader, CardContent } from './ui/card';

const TicketSkeleton = () => (
  <Card className="overflow-hidden w-full transition-all hover:shadow-lg">
    <CardHeader className="border-b bg-primary/5 p-4">
      <div className="h-6 w-full animate-pulse rounded-md bg-muted"></div>
    </CardHeader>
    <CardContent className="space-y-3 p-4">
      <div className="flex flex-col gap-1">
        <div className="flex items-center justify-between">
          <div className="h-4 w-[60rem] animate-pulse rounded-md bg-muted"></div>
          <div className="h-4 w-24 animate-pulse rounded-md bg-muted"></div>
        </div>
        <div className="flex items-center justify-between">
          <div className="h-4 w-28 animate-pulse rounded-md bg-muted"></div>
          <div className="h-4 w-24 animate-pulse rounded-md bg-muted"></div>
        </div>
      </div>
      <div className="space-y-2 rounded-md bg-secondary/20 p-3">
        <div className="h-5 w-20 animate-pulse rounded-md bg-muted"></div>
        <div className="h-4 w-40 animate-pulse rounded-md bg-muted"></div>
        <div className="space-y-1">
          {[1, 2].map((i) => (
            <div key={i} className="flex items-center justify-between">
              <div className="h-4 w-32 animate-pulse rounded-md bg-muted"></div>
              <div className="h-4 w-20 animate-pulse rounded-md bg-muted"></div>
            </div>
          ))}
        </div>
      </div>
    </CardContent>
  </Card>
);
export default TicketSkeleton;
